import { render, staticRenderFns } from "./UserBranchAssignment.vue?vue&type=template&id=afa8a352&"
import script from "./UserBranchAssignment.vue?vue&type=script&lang=js&"
export * from "./UserBranchAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports